const endpoint = "https://lmpb.cuba-lv.com"
const cpoint = "https://central-backend.cuba-lv.com"
const mediapoint = "https://s3-media.cuba-lv.com/"
const startpoint = `${cpoint}/`
const gamePlace = { studio: "tbilisi", room: "po1-room" }
const gameName = "Super Russian"

export { endpoint, mediapoint, startpoint, gamePlace, gameName }
